import React, {createContext, useReducer} from "react";
import {InductProcessReducer} from "../reducers/InductProcessReducer";

export const InductProcessContext = createContext()

const InductProcessContextProvider = (props) => {
    const inductProcessInsight = {
        items: {
            cycleDetailsList: [],
            nodeInductProcessDetails: {
                currentCycleDetails: {},
                isForcedInductEnabled: false
            },
            isNodeEnabled:false
        },
        setNodeInductProcessDetailsModalState : false,
        lastCycle : {},
        currentForceInductStatus : false,
        loading: false,
        message: null
    }
    const [viewModel, dispatch ] = useReducer(InductProcessReducer, inductProcessInsight)
    return (
        <InductProcessContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </InductProcessContext.Provider>
    )
}

export default InductProcessContextProvider


// WEBPACK FOOTER //
// ./src/components/inductManagement/context/InductProcessContext.js